import Component from '@glimmer/component';
import DiagrammStatsSelect from 'bcl/components/diagramm/stats-select';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import eq from 'ember-truth-helpers/helpers/eq';
import or from 'ember-truth-helpers/helpers/or';
import and from 'ember-truth-helpers/helpers/and';
import SelectLocations from 'bcl/components/input/select-locations';
import LocationModel from 'bcl/models/location';
import SelectItems from 'bcl/components/input/select-items';
import ItemModel from 'bcl/models/item';
import RenderPlot from 'bcl/components/diagramm/render-plot';
import InputMonth from './input/month.gts';

interface DiagrammSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class DiagrammComponent extends Component<DiagrammSignature> {
  @tracked startDate: string | null = formatDate(this.lastYear);
  @tracked endDate: string | null = formatDate(new Date());
  @tracked selectedStat: string | null = 'available_amount';
  @tracked location?: LocationModel;
  @tracked selectedItem?: ItemModel;

  @action changeLocation(location: LocationModel) {
    this.location = location;
  }

  @action
  setStartDate(value: string) {
    this.startDate = value;
  }
  @action
  setEndDate(value: string) {
    console.log(value);
    this.endDate = value;
  }

  get lastYear() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date;
  }

  @action
  onChangeStat(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.selectedStat = target.value;
  }
  @action
  changeItem(item: ItemModel) {
    this.selectedItem = item;
  }

  <template>
    <div class="flex items-center gap-4 mb-4">
      <label class="block text-sm font-medium text-gray-700">
        Datum zwischen
        <InputMonth
          class="ml-2"
          @value={{this.startDate}}
          @onChanged={{this.setStartDate}}
        />
      </label>
      <label class="block text-sm font-medium text-gray-700">
        und
        <InputMonth
          class="ml-2"
          @value={{this.endDate}}
          @onChanged={{this.setEndDate}}
        />
      </label>
    </div>
    <DiagrammStatsSelect
      @selectedStat={{this.selectedStat}}
      @onChange={{this.onChangeStat}}
    />
    {{#if
      (or
        (eq this.selectedStat "available_amount")
        (eq this.selectedStat "target_amount")
      )
    }}
      <SelectLocations
        @label="Ort"
        @name="location"
        @onChange={{this.changeLocation}}
        @value={{this.location}}
      />
    {{/if}}
    <SelectItems
      @label="Artikel"
      @name="item"
      @onChange={{this.changeItem}}
      @value={{this.selectedItem}}
    />

    {{#if (and this.location this.selectedItem)}}

      <RenderPlot
        @startDate={{this.startDate}}
        @endDate={{this.endDate}}
        @selectedStat={{this.selectedStat}}
        @location={{this.location}}
        @item={{this.selectedItem}}
      />
    {{/if}}
  </template>
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}
